(function () {
  var DESKTOP_MIN = 768;
  var THUMB_GAP = 11;
  var SCROLL_MS = 550;

  function ProductGallerySidebar(sidebar) {
    this.sidebar = sidebar;
    this.scroller = sidebar.querySelector('[data-gallery-thumbs-scroller]');
    this.thumbsList = sidebar.querySelector('.product-detail__thumbnails');
    this.prevBtn = sidebar.querySelector('[data-gallery-scroll="prev"]');
    this.nextBtn = sidebar.querySelector('[data-gallery-scroll="next"]');
    this.$section = window.jQuery ? window.jQuery(sidebar.closest('[data-section-type="product"]')) : null;
    this.lastActiveIndex = -1;
    this.scrollAnimating = false;

    this.bindEvents();
    this.syncHeights();
    this.cacheActiveIndex();
    this.syncActiveThumbIntoView(false);
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  ProductGallerySidebar.prototype.getThumbs = function () {
    if (!this.thumbsList) {
      return [];
    }

    return Array.prototype.slice.call(this.thumbsList.querySelectorAll('.product-detail__thumbnail'));
  };

  ProductGallerySidebar.prototype.getSlideshow = function () {
    if (!this.$section || !this.$section.length) {
      return null;
    }

    var $slider = this.$section.find('.product-detail__images.slick-initialized');
    return $slider.length ? $slider : null;
  };

  ProductGallerySidebar.prototype.refreshSlideshowPosition = function () {
    var $slider = this.getSlideshow();

    if ($slider) {
      $slider.slick('setPosition');
    }
  };

  ProductGallerySidebar.prototype.cacheActiveIndex = function () {
    var thumbs = this.getThumbs();
    var active = this.thumbsList && this.thumbsList.querySelector('.product-detail__thumbnail.thumb-active');
    this.lastActiveIndex = active ? thumbs.indexOf(active) : 0;
  };

  ProductGallerySidebar.prototype.getThumbByMediaId = function (mediaId) {
    if (!this.thumbsList || mediaId == null) {
      return null;
    }

    return this.thumbsList.querySelector('[data-media-id="' + mediaId + '"]');
  };

  ProductGallerySidebar.prototype.syncHeights = function () {
    if (!this.scroller || !this.sidebar) {
      return;
    }

    var wrapper = this.sidebar.closest('.product-layout-grid__images-and-thumbs');
    var stage = wrapper && wrapper.querySelector('.product-gallery__stage');

    if (!stage) {
      return;
    }

    var sidebarHeight = stage.offsetHeight;
    var prevHeight = this.prevBtn ? this.prevBtn.offsetHeight : 0;
    var nextHeight = this.nextBtn ? this.nextBtn.offsetHeight : 0;
    var gaps = this.prevBtn && this.nextBtn ? THUMB_GAP * 2 : 0;
    var maxScrollHeight = sidebarHeight - prevHeight - nextHeight - gaps;

    if (sidebarHeight > 0 && maxScrollHeight > 0) {
      this.scroller.style.maxHeight = maxScrollHeight + 'px';
      this.sidebar.style.height = sidebarHeight + 'px';
    }

    this.refreshSlideshowPosition();
  };

  ProductGallerySidebar.prototype.scrollToThumb = function (thumb, smooth) {
    if (!this.scroller || !thumb) {
      return;
    }

    var scrollerHeight = this.scroller.clientHeight;
    var thumbOffset = thumb.offsetTop;
    var thumbHeight = thumb.offsetHeight;
    var maxScroll = Math.max(0, this.scroller.scrollHeight - scrollerHeight);
    var targetScroll = clamp(
      thumbOffset - scrollerHeight / 2 + thumbHeight / 2,
      0,
      maxScroll
    );

    if (smooth === false || maxScroll === 0) {
      this.scroller.scrollTop = targetScroll;
      return;
    }

    if (this.scrollAnimating) {
      return;
    }

    var startScroll = this.scroller.scrollTop;
    var distance = targetScroll - startScroll;

    if (Math.abs(distance) < 1) {
      return;
    }

    var startTime = null;
    var self = this;

    this.scrollAnimating = true;

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function step(timestamp) {
      if (!startTime) {
        startTime = timestamp;
      }

      var elapsed = timestamp - startTime;
      var progress = clamp(elapsed / SCROLL_MS, 0, 1);
      self.scroller.scrollTop = startScroll + distance * easeInOutCubic(progress);

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        self.scrollAnimating = false;
      }
    }

    window.requestAnimationFrame(step);
  };

  ProductGallerySidebar.prototype.bindEvents = function () {
    var self = this;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.navigate('prev');
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.navigate('next');
      });
    }

    if (this.$section && this.$section.length) {
      this.$section.on('click.productGallery', '[data-product-media-thumbnail]', function () {
        window.setTimeout(function () {
          self.cacheActiveIndex();
          self.syncActiveThumbIntoView(true);
        }, 0);
      });

      this.bindSlideshowEvents();
      window.jQuery(window).on(
        'debouncedresize.productGallery-' + this.sidebar.dataset.galleryInstance,
        function () {
          self.syncHeights();
          self.bindSlideshowEvents();
        }
      );

      this.$section.on('productGallery:slideshowReady', function () {
        self.bindSlideshowEvents();
        self.syncHeights();
        self.refreshSlideshowPosition();
      });
    }
  };

  ProductGallerySidebar.prototype.bindSlideshowEvents = function () {
    if (!this.$section || !this.$section.length || !window.jQuery) {
      return;
    }

    var self = this;
    var namespace = '.productGalleryThumb-' + (this.sidebar.dataset.galleryInstance || '0');
    var $slider = this.$section.find('.product-detail__images.slick-initialized');

    $slider.off('beforeChange' + namespace).on('beforeChange' + namespace, function (evt, slick, current, next) {
      var $slide = window.jQuery(slick.$slides[next]);
      var mediaId = $slide.find('[data-product-media]').data('media-id');
      var thumb = self.getThumbByMediaId(mediaId);

      if (thumb) {
        self.scrollToThumb(thumb, true);
      }
    });

    $slider.off('afterChange' + namespace).on('afterChange' + namespace, function () {
      self.cacheActiveIndex();
      self.syncActiveThumbIntoView(true);
    });
  };

  ProductGallerySidebar.prototype.navigate = function (direction) {
    var $slider = this.getSlideshow();
    var thumbs = this.getThumbs();

    if (thumbs.length <= 1) {
      return;
    }

    if ($slider) {
      if (direction === 'next') {
        $slider.slick('slickNext');
      } else {
        $slider.slick('slickPrev');
      }
      return;
    }

    var active = this.thumbsList.querySelector('.product-detail__thumbnail.thumb-active');
    var currentIndex = active ? thumbs.indexOf(active) : 0;
    var nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;

    if (nextIndex < 0) {
      nextIndex = thumbs.length - 1;
    } else if (nextIndex >= thumbs.length) {
      nextIndex = 0;
    }

    thumbs[nextIndex].click();
  };

  ProductGallerySidebar.prototype.syncActiveThumbIntoView = function (smooth) {
    var active = this.sidebar.querySelector('.product-detail__thumbnail.thumb-active');

    if (!active) {
      return;
    }

    var thumbs = this.getThumbs();
    var activeIndex = thumbs.indexOf(active);
    var wrapped =
      this.lastActiveIndex !== -1 &&
      thumbs.length > 1 &&
      ((this.lastActiveIndex === thumbs.length - 1 && activeIndex === 0) ||
        (this.lastActiveIndex === 0 && activeIndex === thumbs.length - 1));

    this.scrollToThumb(active, smooth !== false && !wrapped);
    this.lastActiveIndex = activeIndex;
  };

  ProductGallerySidebar.prototype.destroy = function () {
    if (this.$section && this.$section.length && window.jQuery) {
      this.$section.off('.productGallery');
      window.jQuery(window).off('debouncedresize.productGallery-' + this.sidebar.dataset.galleryInstance);
    }
  };

  var galleryInstances = [];
  var mobileGalleryInstances = [];

  function ProductGalleryMobile(nav) {
    this.nav = nav;
    this.prevBtn = nav.querySelector('[data-gallery-mobile-prev]');
    this.nextBtn = nav.querySelector('[data-gallery-mobile-next]');
    this.dots = Array.prototype.slice.call(nav.querySelectorAll('[data-gallery-mobile-dot]'));
    this.$section = window.jQuery ? window.jQuery(nav.closest('[data-section-type="product"]')) : null;

    this.bindEvents();
    this.bindSlideshowEvents();
  }

  ProductGalleryMobile.prototype.getSlideshow = function () {
    if (!this.$section || !this.$section.length) {
      return null;
    }

    var $slider = this.$section.find('.product-detail__images.slick-initialized');
    return $slider.length ? $slider : null;
  };

  ProductGalleryMobile.prototype.setActiveDot = function (index) {
    this.dots.forEach(function (dot, dotIndex) {
      var isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  };

  ProductGalleryMobile.prototype.navigate = function (direction) {
    var $slider = this.getSlideshow();

    if (!$slider || this.dots.length <= 1) {
      return;
    }

    if (direction === 'next') {
      $slider.slick('slickNext');
    } else {
      $slider.slick('slickPrev');
    }
  };

  ProductGalleryMobile.prototype.bindEvents = function () {
    var self = this;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.navigate('prev');
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.navigate('next');
      });
    }

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-gallery-mobile-dot'), 10);
        var $slider = self.getSlideshow();

        if ($slider && !isNaN(index)) {
          $slider.slick('slickGoTo', index);
        }
      });
    });

    if (this.$section && this.$section.length) {
      this.$section.on('productGallery:slideshowReady', function () {
        self.bindSlideshowEvents();
      });
    }
  };

  ProductGalleryMobile.prototype.bindSlideshowEvents = function () {
    if (!this.$section || !this.$section.length || !window.jQuery) {
      return;
    }

    var self = this;
    var $slider = this.getSlideshow();

    if (!$slider) {
      return;
    }

    $slider.off('afterChange.productGalleryMobile').on('afterChange.productGalleryMobile', function (evt, slick, current) {
      self.setActiveDot(current);
    });

    self.setActiveDot($slider.slick('slickCurrentSlide'));
  };

  function initProductGalleryMobile() {
    if (window.innerWidth >= DESKTOP_MIN) {
      return;
    }

    document.querySelectorAll('[data-product-gallery-mobile-nav]').forEach(function (nav) {
      if (nav.dataset.mobileGalleryInit === 'true') {
        return;
      }

      nav.dataset.mobileGalleryInit = 'true';
      var instance = new ProductGalleryMobile(nav);
      mobileGalleryInstances.push(instance);

      window.setTimeout(function () {
        instance.bindSlideshowEvents();
      }, 150);

      window.setTimeout(function () {
        instance.bindSlideshowEvents();
      }, 600);
    });
  }

  function initProductGallery() {
    if (window.innerWidth < DESKTOP_MIN) {
      return;
    }

    document.querySelectorAll('[data-product-gallery-sidebar]').forEach(function (sidebar, index) {
      if (sidebar.dataset.galleryInit === 'true') {
        return;
      }

      sidebar.dataset.galleryInit = 'true';
      sidebar.dataset.galleryInstance = String(index);
      var instance = new ProductGallerySidebar(sidebar);
      galleryInstances.push(instance);

      window.setTimeout(function () {
        instance.syncHeights();
        instance.bindSlideshowEvents();
        instance.refreshSlideshowPosition();
        instance.cacheActiveIndex();
        instance.syncActiveThumbIntoView(false);
      }, 150);

      window.setTimeout(function () {
        instance.syncHeights();
        instance.bindSlideshowEvents();
        instance.refreshSlideshowPosition();
        instance.cacheActiveIndex();
      }, 600);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductGallery();
    initProductGalleryMobile();
  });
  document.addEventListener('shopify:section:load', function () {
    initProductGallery();
    initProductGalleryMobile();
  });
  window.addEventListener('resize', function () {
    galleryInstances.forEach(function (instance) {
      instance.syncHeights();
    });
  });
})();
